import { getDataSource } from "./qRules.dataSource.helpers";
import { selectAndSetNodeValueAsync } from "./qRules.node.helpers";


export const DATA_SOURCE_NAME_QDABRA_RULES = 'QdabraRules';
const qRulesIsSwappingDomXPath = '/QdabraRules/@isSwappingDom';

export const setIsSwappingDom = (dataSources, value) => {
    const domQRules = getDataSource(dataSources, DATA_SOURCE_NAME_QDABRA_RULES);

    return selectAndSetNodeValueAsync(domQRules, qRulesIsSwappingDomXPath, value);
};

